import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const TableEquipmentsSkeleton = () => {
  return [...Array(5)].map(() => (
    <tr key={uuidv4()} className={style.skeletonRow}>
      <td key={uuidv4()}>
        <SkeletonBlock className={style.skeletonCheckbox} />
      </td>
      {[...Array(8)].map(() => (
        <td key={uuidv4()}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
      ))}
    </tr>
  ));
};

export default TableEquipmentsSkeleton;
